import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-arcn-range',
  templateUrl: './arcn-range.component.html',
  styleUrls: [],
  standalone: false
})
export class ARCNRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
